<template>
    <div>
        <div v-if="step ==1" class="mt20">
             <vx-card title="">
                <div class="vx-row items-center">
                    <vs-input style="width: 50%;" v-model="search" v-on:keyup.enter="artistCall"/>
                    <vs-button @click="artistCall" class="ml-3 inline " >검색</vs-button>
                    <vs-button color="success" @click="contributorReg" class="ml-3 inline " >참가자 등록</vs-button>
                </div>
            </vx-card>
            <ul class=" mt-6 contributorList mt20">
                 <template v-for="(item, index) in artistList">
                     <li  style="border: 1px solid; border-radius: 8px; padding: 10px;">
                        <div class="flex" style="justify-content: space-between; align-items: center;">
                            <span style="cursor:pointer;" @click="selectStep(item)">{{ item.name }}</span>
                            <vs-button class="small" style="padding:5px; font-size:12px;" color="primary" @click.stop="editContributor(item)" type="filled">이름수정</vs-button>
                        </div>
                    </li>
                 </template>
            </ul>
            <div class="textCenter" style=" line-height: 130px;" v-if="artistList?.length == 0 "> No Result</div>

             <div class="vx-row">
                <div class="vx-col m-auto mt-6">
                    <vs-button color="danger" @click.native="closeModal('contributor')" type="filled">닫기</vs-button>
                </div>
            </div>
        </div>
        <div v-if="step == 2" class="mt20 infoBox">
             <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>이름</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                        {{ selectContributor.name }}
                </div>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Role</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                    <div class="vx-row">
                        <v-select
                        class=" sm:w-2/3 mr-2 "
                        placeholder="검색구분"
                        label="label_ko"
                        appendToBody
                        v-model="roleValue"
                        :options="optionData.roles"
                        :clearable="false" >
                        </v-select>
                        <vs-button  @click="addRole" type="filled">추가</vs-button>
                    </div>
                    <div class="mt-3">
                        <ul>
                            <li v-for="role in selectContributor.role" style="display: inline-block; margin-right: 10px; ">
                                {{ transRole(role) }}
                                <vs-button class="small" style="padding:5px; font-size: 12px;" color="danger" @click="removeRole({value: role})" type="filled">삭제</vs-button>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Instruments</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                        <div class="vx-row ">
                        <v-select
                        class=" sm:w-2/3 mr-2 "
                        placeholder="검색구분"
                        appendToBody
                        :options="optionData.instruments"
                        label="label_ko"
                        v-model="instValue"
                        :clearable="false" >
                    </v-select>
                        <vs-button  @click="addInst" type="filled">추가</vs-button>
                    </div>
                    <div class="mt-3">
                        <ul>
                            <li v-for="inst in selectContributor.instrument" style="display: inline-block; margin-right: 10px; ">
                                {{ transInstrument(inst) }}
                                <vs-button class="small" style="padding:5px; font-size: 12px;" color="danger" @click="removeInst({value: inst})" type="filled">삭제</vs-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Apple Music</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full">
                    <label style="display:flex; align-items:center; gap:10px; cursor:pointer; padding:9px 12px; border-radius:6px; border:1px solid rgba(252,60,68,0.2); background:rgba(252,60,68,0.06);">
                        <input type="checkbox" v-model="isPrimary" style="accent-color:#fc3c44; width:15px; height:15px; cursor:pointer; flex-shrink:0;" />
                        <div>
                            <span style="font-size:13px; font-weight:600; color:#e0e0e0;">Primary Artist</span>
                            <span style="display:block; font-size:11px; color:#8892b0; margin-top:2px;">애플 뮤직 아티스트 페이지에 대표 아티스트로 표시됩니다</span>
                        </div>
                    </label>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col m-auto mt-6">
                    <vs-button color="danger" @click.native="closeModal('contributor')" type="filled">닫기</vs-button>
                    <vs-button class="ml-2"  @click.native="addContributor('contributorEdit')" type="filled">저장</vs-button>
                </div>
            </div>
        </div>

        <v-modal name="contributorV2Edit" title="'참여자 정보 수정'" width="900px" height="auto" :button="false">
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem" class="card-color darkWhiteColor">
                    <strong>참여자 정보 수정</strong>
                </div>
                <div class="modalCont darkWhiteColor" style="padding:1rem">
                    <div class="vx-row items-center mb-6">
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>이름</span>
                        </div>
                        <div class="vx-col sm:w-5/6 items-center w-full ">
                            <vs-input style="width: 50%;" v-model="editContributorData.name" />
                        </div>
                    </div>
                    <div class="vx-row items-center mb-6">
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>참여자명(번역)</span>
                        </div>
                        <div class="vx-col sm:w-5/6 items-center w-full">
                            <multiLang :langList="editContributorData.name_multilang" title="참여자명" @changeUpdate="updateEditNameMultilang"/>
                        </div>
                    </div>
                    <div class="vx-row items-center mb-6">
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>참여자명(스토어별)</span>
                        </div>
                        <div class="vx-col sm:w-5/6 items-center w-full">
                            <djLang :langList="editContributorData.name_export" title="참여자명" @changeUpdate="updateEditNameExport"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>External ID</span>
                        </div>
                        <div class="vx-col sm:w-5/6 items-center w-full">
                            <div class="vx-row mb-3">
                                <div class="vx-col sm:w-1/4">
                                    <v-select class="w-full" placeholder="타입"
                                        v-model="editExternalType"
                                        :options="externalOptions"
                                        :clearable="false"/>
                                </div>
                                <div class="vx-col sm:w-1/2">
                                    <vs-input class="w-full" v-model="editExternalValue" placeholder="ID"/>
                                </div>
                                <div class="vx-col" style="align-self:center;">
                                    <vs-button @click="addEditExternal" type="filled">추가</vs-button>
                                </div>
                            </div>
                            <vs-table :data="editContributorData.id_external">
                                <template slot="thead">
                                    <vs-th>타입</vs-th>
                                    <vs-th>ID</vs-th>
                                    <vs-th></vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>{{ tr.type }}</vs-td>
                                        <vs-td>{{ tr.value }}</vs-td>
                                        <vs-td>
                                            <vs-button color="danger" style="padding:5px 10px;" @click="removeEditExternal(indextr)">x</vs-button>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col m-auto mt-6">
                            <vs-button color="danger" @click="closeModal('contributorV2Edit')" type="filled">취소</vs-button>
                            <vs-button class="ml-2" @click.native="saveContributorEdit" type="filled">저장</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </v-modal>

        <div v-if="step == 3" class="mt20 infoBox">
            <div style="padding:0.5rem 0 1rem" class="darkWhiteColor">
                <strong>참여자 추가</strong>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>이름</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                    <vs-input style="width: 50%;" v-model="selectContributor.name" />
                </div>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Role</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                    <div class="vx-row">
                        <v-select
                        class=" sm:w-2/3 mr-2 "
                        placeholder="검색구분"
                        label="label_ko"
                        appendToBody
                        v-model="roleValue"
                        :options="optionData.roles"
                        :clearable="false" >
                        </v-select>
                        <vs-button  @click="addRole" type="filled">추가</vs-button>
                    </div>
                    <div class="mt-3">
                        <ul>
                            <li v-for="role in selectContributor.role" style="display: inline-block; margin-right: 10px; ">
                                {{ transRole(role) }}
                                <vs-button class="small" style="padding:5px; font-size: 12px;" color="danger" @click="removeRole({value: role})" type="filled">삭제</vs-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Instruments</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full ">
                    <div class="vx-row ">
                        <v-select
                        class=" sm:w-2/3 mr-2 "
                        placeholder="검색구분"
                        appendToBody
                        :options="optionData.instruments"
                        label="label_ko"
                        v-model="instValue"
                        :clearable="false" >
                        </v-select>
                        <vs-button  @click="addInst" type="filled">추가</vs-button>
                    </div>
                    <div class="mt-3">
                        <ul>
                            <li v-for="inst in selectContributor.instrument" style="display: inline-block; margin-right: 10px; ">
                                {{ transInstrument(inst) }}
                                <vs-button class="small" style="padding:5px; font-size: 12px;" color="danger" @click="removeInst({value: inst})" type="filled">삭제</vs-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="vx-row items-center mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Apple Music</span>
                </div>
                <div class="vx-col sm:w-5/6 items-center w-full">
                    <label style="display:flex; align-items:center; gap:10px; cursor:pointer; padding:9px 12px; border-radius:6px; border:1px solid rgba(252,60,68,0.2); background:rgba(252,60,68,0.06);">
                        <input type="checkbox" v-model="isPrimary" style="accent-color:#fc3c44; width:15px; height:15px; cursor:pointer; flex-shrink:0;" />
                        <div>
                            <span style="font-size:13px; font-weight:600; color:#e0e0e0;">Primary Artist</span>
                            <span style="display:block; font-size:11px; color:#8892b0; margin-top:2px;">애플 뮤직 아티스트 페이지에 대표 아티스트로 표시됩니다</span>
                        </div>
                    </label>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col m-auto mt-6">
                    <vs-button color="danger" @click="step = 1" type="filled">취소</vs-button>
                    <vs-button class="ml-2" @click.native="addContributor('contributorEdit')" type="filled">저장</vs-button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import optionData from '@/optionData/data'
export default {

  name: 'artist',
  props: {
    value: {
      default : []
    },
    type: {
        type: String,
        default: 'release',
    },
    stepSet : {
        default: 1,
    },
  },
  emits: ['update:modelValue'],
  data(){
    return({
        optionData : optionData,
        roleList : optionData.roles,
        instrumentList : optionData.instruments,
        various_artist : false,
        artistList : [

        ],
        selecArtist : [],
        selectContributor : {},
        editContributorData : { id: null, name: null, name_multilang: {}, name_export: {}, id_external: [] },
        externalOptions: ['spotify', 'apple', 'melon'],
        editExternalType: 'spotify',
        editExternalValue: null,
        search :null,
        step:1,
        roleValue:null,
        instValue : null,
        isPrimary: false,
    })
  },
    computed: {
    },
    created(){
        this.step = this.stepSet
        console.log(this.modelValue)

        this.artistCall()

    },
    beforeUnmount() {
        this.emitter.off('contributorAdd')
    },
    watch: {
        various_artist(newVal) {
            this.selecArtist = newVal?newVal:[]
        }
    },
  methods: {
    addRole(data){
        if(this.selectContributor.role.includes(this.roleValue.value)){
            this.alert({msg: '이미 추가된 Role입니다.'})
            return false
        }
        this.selectContributor.role.push(this.roleValue.value)
        this.roleValue = null
    },
    removeRole(data){
        let index = this.selectContributor.role.findIndex(val => {
            return val == data.value
        })
        if(index > -1){
            this.selectContributor.role.splice(index,1)
        }
    },
    addInst(data){

        if(this.selectContributor.instrument.includes(this.instValue.value)){
            this.alert({msg: '이미 추가된 Instrument입니다.'})
            return false
        }
        this.selectContributor.instrument.push(this.instValue.value)

        this.instValue = null
    },
    removeInst(data){
        let index = this.selectContributor.instrument.findIndex(val => {
            return val == data.value
        })
        if(index > -1){
            this.selectContributor.instrument.splice(index,1)
        }
    },

    artistCall () {
        // this.loadingShow();
        let payload = {
            id : this.$route.params.id,
            sort:'created_at',
            sortorder:"DESC",
            name : this.search,
        }
        this.$store.dispatch("GET_CONTRIBUTORS_V2", payload).then(result => {
            this.loadingHide();
            let t = result

            this.artistList = t
        }).catch((message) => {

        });

    },
    artistCheck(item){

        let index = this.selecArtist.find(val => {
            return val.id == item.id
        })
        return index
    },
    artistDelete(item){
        let index = this.selecArtist.findIndex(val => {
            return val.id == item.id
        })
        if(-1 < index){
            this.selecArtist.splice(index,1)
        }
    },
    close(name){
        this.closeModal('artist')
        this.closeModal('trackArtist')
        this.closeModal('featuringArtist')
    },
    saveArtist(){

        this.$emit('update:modelValue', this.selecArtist)
        this.closeModal('artist')
        this.closeModal('trackArtist')
        this.closeModal('featuringArtist')

    },

    selectStep(data){
        let index = this.selecArtist.findIndex(val => {
            return val.id == data.id
        })
        if(index > -1){
            this.alert({msg: ('이미 추가된 아티스트입니다.')})
            return false
        }
        this.selectContributor = {
            id : data.id,
            name : data.name,
            role : [],
            instrument : [],
            is_primary : false,
        }
        this.isPrimary = false
        this.step = 2
    },
    addContributor(){
        let data = { ...this.selectContributor, is_primary: this.isPrimary }

        if(!data.role.length && !data.instrument.length){
            this.alert({msg: ('한가지 이상의 Role 또는 Instrument을 선택해주세요.')})
            return false
        }
        let dd = this.value
        dd.push(data)
        this.$emit('input', dd)
        this.closeModal('contributor')
    },
    contributorReg(){
        this.selectContributor = {
            name : null,
            role:[],
            instrument : [],
            is_primary: false,
        }
        this.isPrimary = false
        this.step = 3
    },
    editContributor(item){
        this.editContributorData = {
            id : item.id,
            name : item.name,
            name_multilang : item.name_multilang ? { ...item.name_multilang } : {},
            name_export : item.name_export ? { ...item.name_export } : {},
            id_external : Array.isArray(item.id_external) ? JSON.parse(JSON.stringify(item.id_external)) : [],
        }
        this.editExternalType = 'spotify'
        this.editExternalValue = null
        this.openModal('contributorV2Edit')
    },
    updateEditNameMultilang(data){
        this.editContributorData.name_multilang = data
    },
    updateEditNameExport(data){
        this.editContributorData.name_export = data
    },
    addEditExternal(){
        if(!this.editExternalType){
            this.alert({msg: '타입을 선택해주세요.'})
            return false
        }
        if(!this.editExternalValue){
            this.alert({msg: 'ID를 입력해주세요.'})
            return false
        }
        for (const item of this.editContributorData.id_external) {
            if (item.type === this.editExternalType) {
                this.alert({msg: '이미 등록된 타입입니다.'})
                return false
            }
        }
        this.editContributorData.id_external.push({
            type: this.editExternalType,
            value: this.editExternalValue,
        })
        this.editExternalValue = null
    },
    removeEditExternal(index){
        this.editContributorData.id_external.splice(index, 1)
    },
    saveContributorEdit(){
        if(!this.editContributorData.name){
            this.alert({msg: '참여자 이름을 입력해주세요.'})
            return false
        }
        for (const key in this.editContributorData.name_multilang) {
            if (!this.editContributorData.name_multilang[key]) {
                delete this.editContributorData.name_multilang[key]
            }
        }
        for (const storeKey in this.editContributorData.name_export) {
            const inner = this.editContributorData.name_export[storeKey]
            if (inner && typeof inner === 'object') {
                for (const langKey in inner) {
                    if (!inner[langKey]) delete inner[langKey]
                }
                if (Object.keys(inner).length === 0) {
                    delete this.editContributorData.name_export[storeKey]
                }
            }
        }
        const payload = {
            id : this.editContributorData.id,
            name : this.editContributorData.name,
            name_multilang : this.editContributorData.name_multilang,
            name_export : this.editContributorData.name_export,
            id_external : this.editContributorData.id_external,
        }
        this.$store.dispatch('PUT_CONTRIBUTOR_V2', payload).then(() => {
            this.noti('수정되었습니다.')
            this.closeModal('contributorV2Edit')
            this.artistCall()
        }).catch(error => {
            this.alert({msg: error.response?.data?.message || '수정 실패'})
        })
    }
  },
  watch: {

  },

}
</script>
